module.exports = __webpack_public_path__ + "img/w4.1f65a7c9.jpg";